/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Delivery_Sla_BreachesInputs */

const vi_dashboard_manager_delivery_sla_breaches = /** @type {(inputs: Dashboard_Manager_Delivery_Sla_BreachesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi phạm SLA`)
};

/**

* @param {Dashboard_Manager_Delivery_Sla_BreachesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_delivery_sla_breaches = /** @type {((inputs?: Dashboard_Manager_Delivery_Sla_BreachesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Delivery_Sla_BreachesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_delivery_sla_breaches(inputs)
});